// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3TQN1","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__-FD8w"};